import {
    SqlObjectMetadataDto,
    SqlRoutineMetadataDto,
    SqlTableMetadataDto,
    SqlUserInfoDto,
} from "../API";

const compositeKey = (...parts: Array<string | undefined>) => JSON.stringify(parts.map((part) => part ?? ""));

// Fluent UI supplies absent items for shimmer rows and falls back to its placeholder index.
export const getSqlTableMetadataKey = (item?: SqlTableMetadataDto | null) =>
    item == null ? undefined : compositeKey("table", item.schemaName, item.tableName);

export const getSqlViewMetadataKey = (item?: SqlTableMetadataDto | null) =>
    item == null ? undefined : compositeKey("view", item.schemaName, item.tableName);

export const getSqlProcedureMetadataKey = (item?: SqlRoutineMetadataDto | null) =>
    item == null ? undefined : compositeKey("procedure", item.schemaName, item.routineName);

export const getSqlFunctionMetadataKey = (item?: SqlRoutineMetadataDto | null) =>
    item == null ? undefined : compositeKey("function", item.schemaName, item.routineName);

export const getSqlUserMetadataKey = (item?: SqlUserInfoDto | null) =>
    item == null ? undefined : compositeKey("user", item.userName);

export const getSqlObjectMetadataKey = (item?: SqlObjectMetadataDto | null) =>
    item == null ? undefined : compositeKey(
        item.objectType,
        item.schemaName,
        item.objectName,
        item.parentSchemaName,
        item.parentObjectName,
    );
